module.exports = __webpack_public_path__ + "static/people_img10-624e00f3cfe6be4226faab2f31c2ca70.png";